import { Injectable } from '@angular/core';

@Injectable()
export class AppNavbarVerticalService {
    navBarRef;

    constructor() {
        // This is intentional
    }

    setNavBar(ref) {
        this.navBarRef = ref;
    }

    getNavBar() {
        return this.navBarRef;
    }
}
